import ErrorBoundary from "@/components/shared/ErrorBoundary";
import { DokumenterTab } from "@/components/project/DokumenterTab";
import { useProjectDetailContext } from "@/contexts/ProjectDetailContext";

export default function DocumentsPage() {
  const { project } = useProjectDetailContext();
  return (
    <ErrorBoundary>
      <DokumenterTab projectId={project.id} offerPdfUrl={project.offer_pdf_url} />
    </ErrorBoundary>
  );
}
